import _objectWithoutPropertiesLoose from '../../../@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js';
import _extends from '../../../@babel/runtime/helpers/esm/extends.js';
import React__default, { forwardRef } from 'react';
import FocusLock from './Lock.js';
import FocusTrap from './Trap.js';

var FocusLockCombination = /*#__PURE__*/forwardRef(function FocusLockUICombination(props, ref) {
  return /*#__PURE__*/React__default.createElement(FocusLock, _extends({
    sideCar: FocusTrap,
    ref: ref
  }, props));
});
var _ref = FocusLock.propTypes || {};
  _ref.sideCar;
  var propTypes = _objectWithoutPropertiesLoose(_ref, ["sideCar"]);
FocusLockCombination.propTypes = process.env.NODE_ENV !== "production" ? propTypes : {};

export { FocusLockCombination as default };
//# sourceMappingURL=Combination.js.map
